import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/star-method-builder/STARBuilderContent.tsx");
